import React from 'react'
import { styled } from '@mui/material/styles'
import { capitalizeWords } from '@helpers/string-helper'
import { useTest } from '@hooks/useTest'
import { addToDataLayer } from '@helpers/google-tag-manager'
import ProductColor from '../../../../@rtg2022/components/atoms/ProductColor'
import { useBaseCollectionTileContext } from '../BaseCollectionTileContext'

const SwatchesWrapper = styled('div')(() => ({
  display: 'flex',
  gap: '10px',
  padding: '4px 0',
  marginLeft: '4px',
  width: 'fit-content',
  zIndex: 1,
}))

const Swatches = () => {
  const { activeColor, handleColorClick, swatchData, collection } = useBaseCollectionTileContext()
  const { title } = collection ?? {}
  const { generateTestId } = useTest()

  if (!swatchData) return null

  return (
    <SwatchesWrapper
      role="radiogroup"
      aria-label="Available colors"
      data-testid={generateTestId('collection-tile', 'swatches')}
    >
      {swatchData
        .map(swatch => {
          if (!swatch?.image) return null
          return (
            <ProductColor
              key={swatch.label}
              color={{
                image: swatch.image,
                label: capitalizeWords(swatch.label),
                sku: '',
                title: '',
              }}
              width="36px"
              height="36px"
              isSelected={activeColor === swatch.label}
              onClick={e => {
                handleColorClick(swatch.label)
                addToDataLayer('click', 'CLP', 'color swatch select', title, swatch.label)
              }}
              variant="collectionTile"
              disableEventPropagation
              position="relative"
            />
          )
        })
        .filter(Boolean)}
    </SwatchesWrapper>
  )
}

export default Swatches
